// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class DispatchedToProviderCasesResource extends Resource {
    basePath: string = 'cases/dispatched-to-provider/';

    objectPath: string = 'cases/dispatched-to-provider/{ident}/';
}
